import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=36e1abeb&scoped=true&"
import script from "./Footer.js?vue&type=script&lang=js&"
export * from "./Footer.js?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=36e1abeb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e1abeb",
  null
  
)

export default component.exports